export default "__VITE_ASSET__BbOeVyaS__"